import React from "react";
import { Datagrid, TextField, DateField, Link } from "react-admin";
import { List } from "../../../components/customize-react-admin";
import Pagination from "../../../components/qa/Pagination";
import LikeTargetField from "../../../components/qa/LikeTargetField";
import { UserLinkField } from "../../../components/qa/LinkFields";

const IDLinkField = props => (
  <Link to={`/likes/${props.record.id}/show`}>
    <TextField {...props} />
  </Link>
);

export const LikeList = props => {
  const perPage = 50;
  const defaultSort = {
    field: "time.created",
    order: "DESC"
  };
  return (
    <List
      {...props}
      title="按讚列表"
      perPage={perPage}
      sort={defaultSort}
      pagination={<Pagination />}
    >
      <Datagrid>
        <IDLinkField source="id" label="ID" sortable={false} />
        <UserLinkField label="按讚者" size={30} sortable={false} />
        <TextField source="target.type" label="按讚目標類型" sortable={false} />
        <LikeTargetField label="按讚目標" />
        <TextField source="type" label="讚類型" sortable={false} />
        <DateField showTime source="time.created" label="建立時間" />
      </Datagrid>
    </List>
  );
};
